import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <----------------------- Rss Feed List ----------------------->
// ###############################################################
export const Wrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 2fr 3fr 1fr 3fr 1fr 3fr 3fr;
  column-gap: 16px;
  padding: 0 24px;
`;

export const Divider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 8;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const Header = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 68px;
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  min-height: 68px;

  & > * + * {
    margin-inline-start: 6px;
  }

  ${({ padding }) =>
    padding &&
    `
    padding-bottom: 6px;
`}
`;

export const ItemTextWrapper = styled.div`
  display: inline-block;
  padding: 1px 4px;
  border-radius: 4px;
  background-color: ${({ backgroundColor }) => backgroundColor || ''};
  border: 1px solid ${({ borderColor }) => borderColor || ''};
`;

export const ItemLink = styled(Link)`
  text-decoration: none;
`;

export const ItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme, color }) => color || theme.colors.black};
`;

export const ItemClick = styled(ItemText)`
  cursor: pointer;
`;

export const ItemHoverWrapper = styled.div`
  position: absolute;
  top: 50%;
  display: none;
  width: 80vw;
  transform: translateY(20px);
  z-index: 1;
`;

export const ItemHover = styled(typography.BodyTextThreeRegularTypography)`
  width: fit-content;
  padding: 6px 8px;
  color: white;
  background-color: ${({ theme }) => theme.colors.overlay};
  border-radius: 4px;
`;

export const ItemColumnWithHover = styled(ItemColumn)`
  &:hover {
    ${ItemHoverWrapper} {
      display: block;
    }
  }
`;

export const ItemTag = styled(typography.BodyTextThreeRegularTypography)`
  margin: 0;
  padding: 2px 4px;
  width: fit-content;
  color: ${({ theme }) => theme.colors.primaryMain};
  background-color: ${({ theme }) => theme.colors.primaryLight};
  border-radius: 4px;
  text-align: center;

  ${({ margin }) =>
    margin &&
    `
    margin: 6px 6px 0 0 ;
  `}

  ${({ hover }) =>
    hover &&
    `
    cursor: pointer;
  `}
`;

export const ItemBtnWithText = styled(typography.BodyTextTwoRegularTypography)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  color: ${({ theme, color }) => color || theme.colors.white};
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.primaryMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;
`;
// ###############################################################
// <-------------------- End Rss Feed List ---------------------->
// ###############################################################

// ###############################################################
// <-------------------- Post Actions Popup --------------------->
// ###############################################################
export const ActionsPopupWrapper = styled.div`
  padding: 30px 0;
  min-width: 550px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const ActionsPopupTitleWrapper = styled.div`
  text-align: center;
`;

export const ActionsPopupTitle = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const ActionsPopupBtnWrapper = styled.div`
  display: flex;
  padding: 0 20px;

  & * + * {
    margin-inline-start: 15px !important;
  }
`;

export const ActionsPopupYesBtn = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 8px 0;
  width: 60px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.greenMain};
  border: 0;
  border-radius: 4px;
  cursor: pointer;
`;

export const ActionsPopupNoBtn = styled(ActionsPopupYesBtn)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
  background-color: ${({ theme }) => theme.colors.redLight};
`;
// ###############################################################
// <------------------ End Post Actions Popup ------------------->
// ###############################################################
